'use strict';

import BaseService from './base.service';
import Promise from 'bluebird';

class ReceiptsService extends BaseService {
    /* @ngInject */
    constructor(
        Receipt,
        Quote,
        ReceiptQuote,
        PaymentItem,
        BankTx,
        Check,
        SegaUser
    ) {
        super(Receipt);
        Object.assign(this, {
            Quote,
            ReceiptQuote,
            PaymentItem,
            BankTx,
            Check,
            SegaUser
        });
    }

    _getExtraConstraints(qOpts) {
        return Promise.resolve().then(() => {
            if (qOpts.where && qOpts.where.vehicleId) {
                // Vehicle constraint
                let vehicleId = qOpts.where.vehicleId;
                delete qOpts.where.vehicleId;

                return this.Quote.find({
                    filter: {
                        where: {
                            vehicleId: vehicleId
                        },
                        include: 'receipts',
                        deleted: qOpts.deleted
                    }
                }).$promise.then(quotes => {
                    let ids = quotes.reduce((a, b) => {
                        return a.concat(b.receipts.map(r => r.id));
                    }, []);
                    qOpts.where.id = {
                        inq: ids
                    };
                });
            }
        });
    }

    getModels(opts) {
        // TODO: try to make just one call to getExtraConstraints
        let qOpts = JSON.parse(JSON.stringify(opts));
        return this._getExtraConstraints(qOpts).then(() => {
            return super.getModels(qOpts);
        });
    }

    getCount(opts) {
        // TODO: try to make just one call to getExtraConstraints
        let qOpts = JSON.parse(JSON.stringify(opts));
        return this._getExtraConstraints(qOpts).then(() => {
            return super.getCount(qOpts);
        });
    }

    addQuote(opts) {
        let rq = new this.ReceiptQuote({
            receiptId: opts.receiptId,
            quoteId: opts.quoteId
        });
        return this.Model.quotes.findById({
            id: opts.receiptId,
            fk: opts.quoteId
        }).$promise.then(existing => {
            // Do nothing, already exists
            return Promise.resolve();
        }, err => {
            // that findById rejects the promise when not found
            return this.ReceiptQuote.upsert(rq).$promise;
        });
    }

    removeQuote(opts) {
        return this.Model.quotes.destroyById({
            id: opts.receiptId,
            fk: opts.quoteId
        }).$promise;
    }

    createPaymentItem(opts = {receipt: null}) {
        let paymentItem = new this.PaymentItem({
            amount: 0,
            type: 'cash'
        });
        return paymentItem;
    }

    savePaymentItems(opts = {receipt: null, instances: []}) {
        let totalAmount = 0;
        return Promise.each(opts.instances, paymentItem => {
            let checkData = paymentItem.check,
                bankTxData = paymentItem.bankTx;
            paymentItem.receipt = opts.receipt;
            totalAmount += paymentItem.amount;
            return this.PaymentItem.upsert(paymentItem)
                .$promise
                .then(paymentItem => {
                    if (paymentItem.type == 'check') {
                        let check = new this.Check({
                            paymentItem: paymentItem,
                            date: checkData.date,
                            number: checkData.number,
                            clientId: opts.receipt.clientId,
                            amount: paymentItem.amount
                        });
                        return check.$save();
                    } else if (paymentItem.type == 'bankTx') {
                        let bankTx = new this.BankTx({
                            paymentItem: paymentItem,
                            date: bankTxData.date,
                            externalId: bankTxData.externalId,
                            clientId: opts.receipt.clientId,
                            amount: paymentItem.amount
                        });
                        return bankTx.$save();
                    }
                });
        }).then(() => {
            return totalAmount;
        });
    }

    void(receiptId) {
        return this.Receipt.void({
            id: receiptId
        }).$promise;
    }

    getReceiptsForQuote(quoteId, qOpts) {
        let filter = super.getQueryOpts(qOpts);
        delete filter.where; // just in case
        return this.Quote.receipts({
            id: quoteId,
            filter: filter
        }).$promise;
    }

    countReceiptsForQuote(quoteId, qOpts) {
        let filter = super.getQueryOpts(qOpts);
        delete filter.where; // just in case
        return this.Quote.receipts.count({
            id: quoteId,
            filter
        }).$promise;
    }

    createNew(opts = {receipt: null, quotes: [], paymentItems: []}) {
        return this.Model.createNew(opts).$promise;
    }

    createForGroupInvoice(
        opts = {receipt: null, groupInvoiceData: [], paymentItems: []}
    ) {
        return this.Model.createForGroupInvoice(opts).$promise;
    }

    updateInvoiceNumber(opts = {id: null, invoiceNumber: null}) {
        return this.Model.updateInvoiceNumber(opts).$promise;
    }
}

export default ReceiptsService;
